import Cookies, { CookieAttributes } from 'js-cookie';
import { decode } from 'jsonwebtoken';
import type { Token } from './api';

class TokenManager {
  private readonly ACCESS_TOKEN_NAME: string;
  private readonly REFRESH_TOKEN_NAME: string;
  private cookies: CookieAttributes;
  private token: Token;

  constructor(prefix: string) {
    this.cookies = Cookies;
    this.token = {
      accessToken: undefined,
      refreshToken: undefined,
    };
    this.ACCESS_TOKEN_NAME = `${prefix}-access_token`;
    this.REFRESH_TOKEN_NAME = `${prefix}-refresh_token`;
  }

  save(token: Token) {
    this.token = token;

    this.cookies.set(this.ACCESS_TOKEN_NAME, token.accessToken, {
      path: '/',
      httpOnly: process.env.COOKIE_HTTPONLY === 'true',
    });
    this.cookies.set(this.REFRESH_TOKEN_NAME, token.refreshToken, {
      path: '/',
      httpOnly: process.env.COOKIE_HTTPONLY === 'true',
      expires: new Date(+new Date() + 3600 * 24 * 7 * 1000),
    });
  }

  getAccessToken() {
    if (typeof this.token.accessToken === 'undefined') {
      this.token.accessToken = this.cookies.get(this.ACCESS_TOKEN_NAME);
    }
    return this.token.accessToken;
  }

  getRefreshToken() {
    if (typeof this.token.refreshToken === 'undefined') {
      this.token.refreshToken = this.cookies.get(this.REFRESH_TOKEN_NAME);
    }
    return this.token.refreshToken;
  }

  isExpired(token: string) {
    const payload = decode(token) as { exp: number };
    if (payload && payload.exp) {
      const clockTimestamp = Math.floor(Date.now() / 1000);
      return clockTimestamp >= payload.exp;
    }
    return true;
  }

  clear() {
    this.token.accessToken = undefined;
    this.token.refreshToken = undefined;

    this.cookies.remove(this.ACCESS_TOKEN_NAME);
    this.cookies.remove(this.REFRESH_TOKEN_NAME);
  }
}

export default TokenManager;
